import { render, staticRenderFns } from "./permissions-section.vue?vue&type=template&id=0bd296aa&scoped=true"
import script from "./permissions-section.vue?vue&type=script&lang=js"
export * from "./permissions-section.vue?vue&type=script&lang=js"
import style0 from "./permissions-section.vue?vue&type=style&index=0&id=0bd296aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd296aa",
  null
  
)

export default component.exports